import { Match } from 'effect';

import type { AdminUser, SiteAdminUser } from '../../types/User';

const ALL_LOCATIONS = 'all' as const;

export const getLocationUrlParamByUser = (user: AdminUser | SiteAdminUser): string =>
    Match.type<typeof user>().pipe(
        Match.withReturnType<string>(),
        // Super admins can see all locations
        Match.when({ type: 'ADMIN' }, () => ALL_LOCATIONS),
        // Site admins can only see their location
        Match.when({ type: 'SITE_ADMIN' }, () => ''),
        Match.exhaustive
    )(user);
